import CTATextContainer from "../Common/CTATextContainer";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import LazyLoadPlaceholder from "../Common/LazyLoadPlaceholder";

function Popular() {
    return (
        <div className="popular-container">
            <h2>Popular</h2>
            <div className="images-container">
                <div className="top-radius"></div>
                <LazyLoadImage src={process.env.PUBLIC_URL + "/images/popular/popular-1.png"} className="img img-lg" placeholder={<LazyLoadPlaceholder />} />
                <LazyLoadImage src={process.env.PUBLIC_URL + "/images/popular/popular-2.png"} className="img img-md" placeholder={<LazyLoadPlaceholder />} />
                <LazyLoadImage src={process.env.PUBLIC_URL + "/images/popular/popular-3.png"} className="img img-sm" placeholder={<LazyLoadPlaceholder />} />
                <LazyLoadImage src={process.env.PUBLIC_URL + "/images/popular/popular-4.png"} className="img img-sm" placeholder={<LazyLoadPlaceholder />} />
                <LazyLoadImage src={process.env.PUBLIC_URL + "/images/popular/popular-5.png"} className="img img-md" placeholder={<LazyLoadPlaceholder />} />
                <LazyLoadImage src={process.env.PUBLIC_URL + "/images/popular/popular-6.png"} className="img img-lg" placeholder={<LazyLoadPlaceholder />} />
            </div>
            <div className="cta-container" style={{ backgroundImage: 'url(' + process.env.PUBLIC_URL + '/images/popular-bg-gradient.png)' }}>
                <div className="overlay overlay-top"></div>
                <div className="overlay overlay-bottom"></div>
                <CTATextContainer context="Popular" />
            </div>
        </div>
    );
}

export default Popular;